/**
 * Module d'Expédition Fractionnée (2 colis) pour Commandes Mixtes
 * IndianShop Réunion - SOYOO
 * Gestion globale des événements (délégation DOM pour résister aux rechargements AJAX innerHTML du drawer)
 */
(function() {
  'use strict';

  // Identifiants vérifiés des variantes du produit logistique dans l'admin Shopify
  const VARIANT_UNDER_80 = 71257698074877; // Commande < 80€ (+4,50€)
  const VARIANT_OVER_80  = 71257698107645; // Commande >= 80€ (+7,50€)

  // Verrou pour empêcher les clics multiples ou requêtes concurrentes
  let isOperating = false;
  let sanitizeTimeout = null;

  /**
   * Helper: Identifie si un article du panier est le produit de livraison fractionnée
   */
  function isSplitItem(item) {
    if (!item) return false;
    const handle = item.handle || (item.product && item.product.handle);
    const prodType = item.product_type || (item.product && item.product.type);
    const variantId = item.variant_id || item.id;
    return (
      handle === 'livraison-fractionnee-2-colis' ||
      prodType === 'Service Logistique' ||
      variantId === VARIANT_UNDER_80 ||
      variantId === VARIANT_OVER_80
    );
  }

  /**
   * Valide si un choix d'expédition a été effectué
   * Bloque le passage à la caisse si aucun radio n'est coché
   */
  function validateSplitShippingChoice(e) {
    const container = document.querySelector('[data-split-shipping-container]');
    if (!container) return true; // Pas de panier mixte affiché

    // Si une opération AJAX est en cours, bloquer temporairement le clic
    if (isOperating) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') {
          e.stopImmediatePropagation();
        }
      }
      return false;
    }

    // Vérifier si un bouton radio est coché
    const checkedRadio = container.querySelector('input[name="split_shipping_choice"]:checked');
    if (!checkedRadio) {
      // Bloquer le checkout !
      if (e) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') {
          e.stopImmediatePropagation();
        }
      }

      // Afficher l'alerte
      const alertBox = container.querySelector('[data-split-alert]');
      if (alertBox) alertBox.style.display = 'flex';

      // Animation secousse (shake)
      container.classList.remove('split-shipping--shake');
      void container.offsetWidth; // Force reflow
      container.classList.add('split-shipping--shake');

      // Scroll vers le bloc
      container.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

      return false;
    }

    return true;
  }

  /**
   * Détermine si le montant réel du panier (hors produit virtuel) est >= 80€
   */
  function getIsOver80(container) {
    if (!container) return false;
    const realSubtotal = parseInt(container.getAttribute('data-real-subtotal') || '0', 10);
    const attrOver80 = container.getAttribute('data-over-80');
    const threshold = parseInt(container.getAttribute('data-free-threshold') || '8000', 10);
    return (attrOver80 === 'true') || (realSubtotal >= threshold);
  }

  /**
   * Gestion du changement de sélection sur les boutons radio
   */
  function handleChoiceChange(radio) {
    if (isOperating) return;
    const container = radio.closest('[data-split-shipping-container]');
    if (!container) return;

    const cards = container.querySelectorAll('.split-shipping__card');
    const loader = container.querySelector('.split-shipping__loader');
    const alertNotice = container.querySelector('[data-split-alert]');
    const tagRequired = container.querySelector('.split-shipping__tag-required');
    const choice = radio.value;

    // Calcul précis du seuil >= 80€
    const isOver80 = getIsOver80(container);

    // Mise à jour visuelle immédiate
    cards.forEach(function(c) { c.classList.remove('is-selected'); });
    const parentCard = radio.closest('.split-shipping__card');
    if (parentCard) parentCard.classList.add('is-selected');

    if (alertNotice) alertNotice.style.display = 'none';
    if (tagRequired) tagRequired.style.display = 'none';
    container.classList.remove('split-shipping--shake');
    container.dataset.choiceMade = 'true';

    // Mémorisation dans la session
    try {
      sessionStorage.setItem('indianshop_split_choice', choice);
    } catch(err) {}

    // Déterminer la variante cible
    const varOver = parseInt(container.getAttribute('data-variant-over') || VARIANT_OVER_80, 10);
    const varUnder = parseInt(container.getAttribute('data-variant-under') || VARIANT_UNDER_80, 10);
    const targetVariantId = isOver80 ? varOver : varUnder;

    // Activer le verrou
    isOperating = true;
    if (loader) loader.style.display = 'flex';

    // Interroger l'état réel du panier Shopify pour synchronisation sans doublons
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        const splitItems = (cart.items || []).filter(isSplitItem);

        if (choice === 'split') {
          // Cas OPTION FRACTIONNEE :
          // Doit contenir targetVariantId en quantité 1, et 0 pour toute autre variante
          let alreadyHasTarget = false;
          const updates = {};
          let needsUpdate = false;

          splitItems.forEach(function(item) {
            const vId = item.variant_id || item.id;
            if (vId === targetVariantId) {
              alreadyHasTarget = true;
              if (item.quantity !== 1) {
                updates[item.key] = 1; // Forcer strictement la quantité à 1
                needsUpdate = true;
              }
            } else {
              updates[item.key] = 0; // Supprimer les variantes obsolètes
              needsUpdate = true;
            }
          });

          if (alreadyHasTarget) {
            // La variante cible est déjà dans le panier : juste corriger les quantités si nécessaire et mettre à jour l'attribut
            const payload = {
              attributes: {
                "Mode d'expédition": "2 envois (Stock sous 48h + Sur commande 10-15j)"
              }
            };
            if (needsUpdate) {
              payload.updates = updates;
            }
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify(payload)
            });
          } else {
            // La variante cible n'est pas encore dans le panier :
            // 1. Purger toute autre variante présente
            const purgePromise = needsUpdate ?
              fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ updates: updates })
              }) : Promise.resolve();

            return purgePromise
              .then(function() {
                // 2. Ajouter la variante cible avec quantité 1
                return fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                  body: JSON.stringify({
                    items: [{ id: targetVariantId, quantity: 1 }]
                  })
                });
              })
              .then(function() {
                // 3. Mettre à jour l'attribut de commande
                return fetch('/cart/update.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                  body: JSON.stringify({
                    attributes: {
                      "Mode d'expédition": "2 envois (Stock sous 48h + Sur commande 10-15j)"
                    }
                  })
                });
              });
          }
        } else if (choice === 'pickup') {
          // Cas OPTION RETRAIT SUR PLACE (McDo La Possession) :
          // Retirer TOUTES les variantes du produit de livraison fractionnée
          const updates = {};
          splitItems.forEach(function(item) {
            updates[item.key] = 0;
          });

          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              updates: updates,
              attributes: {
                "Mode d'expédition": "Retrait gratuit (Parking McDo La Possession)"
              }
            })
          });
        } else {
          // Cas OPTION GROUPEE (Inclus) :
          // Retirer TOUTES les variantes du produit de livraison fractionnée
          const updates = {};
          splitItems.forEach(function(item) {
            updates[item.key] = 0;
          });

          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              updates: updates,
              attributes: {
                "Mode d'expédition": "1 envoi groupé sous 10-15 jours"
              }
            })
          });
        }
      })
      .then(function() {
        refreshCart();
      })
      .catch(function(err) {
        console.error('[SplitShipping] Erreur synchronisation panier :', err);
        isOperating = false;
        if (loader) loader.style.display = 'none';
      });
  }

  /**
   * Assainit le panier : s'assure qu'il n'y a jamais de quantité > 1 ou de doublons
   */
  function sanitizeCartQuantities() {
    if (isOperating) return;
    const container = document.querySelector('[data-split-shipping-container]');
    if (!container) return;

    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        if (!cart || !cart.items || isOperating) return;
        const splitItems = cart.items.filter(isSplitItem);
        if (splitItems.length === 0) return;

        // Si le choix actuel est une option gratuite (grouped ou pickup), purger le produit virtuel
        const checkedRadio = container.querySelector('input[name="split_shipping_choice"]:checked');
        const currentChoice = checkedRadio ? checkedRadio.value : (sessionStorage.getItem('indianshop_split_choice') || '');
        if (currentChoice === 'grouped' || currentChoice === 'pickup') {
          isOperating = true;
          const loader = container.querySelector('.split-shipping__loader');
          if (loader) loader.style.display = 'flex';
          const purgeUpdates = {};
          splitItems.forEach(function(item) { purgeUpdates[item.key] = 0; });
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ updates: purgeUpdates })
          }).then(function() {
            refreshCart();
          }).catch(function() {
            isOperating = false;
            if (loader) loader.style.display = 'none';
          });
          return;
        }

        const isOver80 = getIsOver80(container);
        const varOver = parseInt(container.getAttribute('data-variant-over') || VARIANT_OVER_80, 10);
        const varUnder = parseInt(container.getAttribute('data-variant-under') || VARIANT_UNDER_80, 10);
        const targetVariantId = isOver80 ? varOver : varUnder;

        let hasAnomalies = false;
        const updates = {};

        // Vérifier si des articles ont une quantité > 1 ou une variante non désirée
        splitItems.forEach(function(item) {
          const vId = item.variant_id || item.id;
          if (vId === targetVariantId) {
            if (item.quantity !== 1) {
              updates[item.key] = 1;
              hasAnomalies = true;
            }
          } else {
            // Variante différente (ex: 4,50€ alors que panier >= 80€)
            updates[item.key] = 0;
            hasAnomalies = true;
          }
        });

        const hasTarget = splitItems.some(function(item) {
          return (item.variant_id || item.id) === targetVariantId;
        });

        if (hasAnomalies && hasTarget) {
          isOperating = true;
          const loader = container.querySelector('.split-shipping__loader');
          if (loader) loader.style.display = 'flex';

          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ updates: updates })
          })
          .then(function() {
            refreshCart();
          })
          .catch(function() {
            isOperating = false;
            if (loader) loader.style.display = 'none';
          });
        } else if (hasAnomalies && !hasTarget && splitItems.length > 0) {
          // Ancienne variante à remplacer par la nouvelle cible
          isOperating = true;
          const loader = container.querySelector('.split-shipping__loader');
          if (loader) loader.style.display = 'flex';

          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ updates: updates })
          })
          .then(function() {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: [{ id: targetVariantId, quantity: 1 }] })
            });
          })
          .then(function() {
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({
                attributes: {
                  "Mode d'expédition": "2 envois (Stock sous 48h + Sur commande 10-15j)"
                }
              })
            });
          })
          .then(function() {
            refreshCart();
          })
          .catch(function() {
            isOperating = false;
            if (loader) loader.style.display = 'none';
          });
        }
      })
      .catch(function() {});
  }

  /**
   * Rafraîchissement du panier (Drawer ou page)
   */
  function refreshCart() {
    const finish = function() {
      isOperating = false;
      const loader = document.querySelector('.split-shipping__loader');
      if (loader) loader.style.display = 'none';
    };

    if (window.location.pathname.indexOf('/cart') !== -1) {
      // Sur la page panier complète, recharger pour actualiser les sous-totaux et formulaires
      window.location.reload();
    } else {
      // Recharger le drawer via section API
      const rootUrl = (window.theme && window.theme.routes && window.theme.routes.root_url) || '/';
      fetch(rootUrl + '?section_id=api-cart-items')
        .then(function(r) { return r.text(); })
        .then(function(html) {
          const fresh = document.createElement('div');
          fresh.innerHTML = html;
          const target = document.querySelector('[data-line-items]');
          const source = fresh.querySelector('[data-api-content]');
          if (target && source) {
            target.innerHTML = source.innerHTML;
            restoreSessionChoice();
          } else {
            window.location.reload();
          }
          finish();
        })
        .catch(function() {
          window.location.reload();
        });
    }
  }

  /**
   * Vérifie et purge le produit de livraison fractionnée si le panier n'est plus mixte
   */
  function checkAndCleanOrphanSplitShipping() {
    if (isOperating) return;
    const container = document.querySelector('[data-split-shipping-container]');
    const cartItemsEl = document.querySelector('[data-cart-items]');
    
    // Si le DOM des articles n'est pas encore prêt (chargement AJAX du drawer),
    // ne pas purger prématurément pour éviter des requêtes /cart.js concurrentes inutiles.
    if (!cartItemsEl) return;

    const isMixedCart = (cartItemsEl.getAttribute('data-mixed-cart') === 'true') || !!container;

    // Si le panier n'est pas mixte
    if (!isMixedCart) {
      fetch('/cart.js')
        .then(function(res) { return res.json(); })
        .then(function(cart) {
          if (!cart || !cart.items || isOperating) return;
          const splitItems = cart.items.filter(isSplitItem);
          if (splitItems.length === 0) return; // Rien à purger

          isOperating = true;
          const updates = {};
          splitItems.forEach(function(item) {
            updates[item.key] = 0;
          });
          updates[VARIANT_UNDER_80] = 0;
          updates[VARIANT_OVER_80] = 0;

          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              updates: updates,
              attributes: {
                "Mode d'expédition": ""
              }
            })
          })
          .then(function() {
            try { sessionStorage.removeItem('indianshop_split_choice'); } catch(e) {}
            refreshCart();
          })
          .catch(function(err) {
            console.error('[SplitShipping] Erreur purge orphelin :', err);
            isOperating = false;
          });
        })
        .catch(function() {});
    }
  }

  /**
   * Restaure le choix précédent si l'utilisateur revient du checkout ou vérifie la cohérence
   */
  function restoreSessionChoice() {
    const container = document.querySelector('[data-split-shipping-container]');
    if (!container) {
      checkAndCleanOrphanSplitShipping();
      return;
    }

    // 1. Assainir les quantités en arrière-plan
    clearTimeout(sanitizeTimeout);
    sanitizeTimeout = setTimeout(sanitizeCartQuantities, 200);

    // 2. Vérifier si un radio est déjà coché
    const checkedRadio = container.querySelector('input[name="split_shipping_choice"]:checked');
    if (checkedRadio) {
      container.dataset.choiceMade = 'true';
      const tagRequired = container.querySelector('.split-shipping__tag-required');
      if (tagRequired) tagRequired.style.display = 'none';
      return;
    }

    // 3. Sinon, restaurer depuis le sessionStorage
    try {
      const saved = sessionStorage.getItem('indianshop_split_choice');
      if (saved === 'grouped' || saved === 'split' || saved === 'pickup') {
        const matchingRadio = container.querySelector('input[name="split_shipping_choice"][value="' + saved + '"]');
        if (matchingRadio) {
          matchingRadio.checked = true;
          const parentCard = matchingRadio.closest('.split-shipping__card');
          if (parentCard) parentCard.classList.add('is-selected');
          container.dataset.choiceMade = 'true';
          const tagRequired = container.querySelector('.split-shipping__tag-required');
          if (tagRequired) tagRequired.style.display = 'none';
        }
      }
    } catch(err) {}
  }

  // =========================================================================
  // DÉLÉGATION D'ÉVÉNEMENTS GLOBALE (Survit à innerHTML)
  // =========================================================================

  // 1. Écoute du changement d'option radio
  document.addEventListener('change', function(e) {
    if (e.target && e.target.name === 'split_shipping_choice') {
      handleChoiceChange(e.target);
    }
  });

  // 2. Clic sur le bouton de suppression de la ligne d'expédition fractionnée
  document.addEventListener('click', function(e) {
    const removeBtn = e.target.closest('[data-split-remove]');
    if (removeBtn) {
      e.preventDefault();
      e.stopPropagation();
      const groupedRadio = document.querySelector('input[name="split_shipping_choice"][value="grouped"]');
      if (groupedRadio) {
        groupedRadio.checked = true;
        handleChoiceChange(groupedRadio);
      }
    }
  });

  // 3. Interception des clics sur TOUS les boutons de checkout (phase de capture)
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('button[name="checkout"], input[name="checkout"], .checkout__button, a[href*="/checkout"], [data-checkout-button]');
    if (btn) {
      if (!validateSplitShippingChoice(e)) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') {
          e.stopImmediatePropagation();
        }
        return false;
      }
    }
  }, true);

  // 4. Interception de la soumission de tout formulaire menant au panier/checkout
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (form && (form.id === 'cart-form' || form.matches('form.cart') || (form.action && form.action.includes('/cart')))) {
      if (!validateSplitShippingChoice(e)) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') {
          e.stopImmediatePropagation();
        }
        return false;
      }
    }
  }, true);

  // 5. Initialisation au chargement de la page et lors des mutations DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreSessionChoice);
  } else {
    restoreSessionChoice();
  }

  let observerDebounce = null;

  // Observer pour détecter l'apparition du drawer ou le rechargement AJAX
  const observer = new MutationObserver(function(mutations) {
    if (isOperating) return;
    for (let i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length > 0) {
        clearTimeout(observerDebounce);
        observerDebounce = setTimeout(restoreSessionChoice, 150);
        break;
      }
    }
  });

  document.addEventListener('DOMContentLoaded', function() {
    // Observer uniquement le conteneur des lignes d'articles, pas l'intégralité du drawer
    const lineItemsContainer = document.querySelector('#drawer-cart [data-line-items]') || document.getElementById('drawer-cart');
    if (lineItemsContainer) {
      observer.observe(lineItemsContainer, { childList: true });
    }
    const cartPage = document.querySelector('.template__cart__body') || document.querySelector('[data-cart-form]');
    if (cartPage) {
      observer.observe(cartPage, { childList: true });
    }
  });

  // Événement custom Shopify
  document.addEventListener('cart:updated', function() {
    if (!isOperating) {
      setTimeout(restoreSessionChoice, 150);
    }
  });
})();
